import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import Col from "./Column";
const Avatar = styled("img")`
  height: ${(props) => `${props.size}px`};
  width: ${(props) => `${props.size}px`};
  border: ${(props) =>
    props.loading !== true
      ? `${props.borderSize ? props.borderSize + "px" : "3px"} solid white`
      : "none"};
  border-radius: ${(props) => `${props.size / 2}px`};
  box-shadow: ${(props) => props.loading !== true && props.theme.shadow};
  background-image: ${(props) =>
    props.loading !== true && `url(${props.source})`};
  background-size: ${(props) => props.loading !== true && "contain"};
  box-sizing: border-box;
`;
const StyledAvatar = (props) => {
  const { size, loading, borderSize } = props;
  const theme = useContext(ThemeContext);
  return (
    <Avatar
      {...props}
      size={size || 64}
      borderSize={borderSize}
      loading={loading}
      src={props.source}
      theme={theme}
    />
  );
};

export default StyledAvatar;
